<template>
  <div>
    <div class="topdown-db">
      <div v-if="isEdit === false">
        <a class="mr20" @click="editShow">EDIT</a>
      </div>
      <div v-else>
        <a class="mr20" @click="editShow">CANCEL</a>
        <a v-if="currentTab !== 'matrix_legal_doc'" class="mr20" @click="addShow">ADD</a>
      </div>
    </div>

    <!-- Dokumen -->
    <Default v-if="isAdd & content === 'default'" @closeModal="closeModal" />
    <Akta v-if="isAdd & content === 'akta'" @closeModal="closeModal" />
    <Komersial v-if="isAdd & content === 'komersial'" @closeModal="closeModal" />
    <Perizinan v-if="isAdd & content === 'perizinan'" @closeModal="closeModal" />

    <!-- Badan Usaha -->
    <Nasional v-if="isAdd & content === 'nasional_bu'" @closeModal="closeModal" />
    <Internasional v-if="isAdd & content === 'internasional_bu'" @closeModal="closeModal" />
    <Khusus v-if="isAdd & content === 'khusus_bu'" @closeModal="closeModal" />
    <InternalMemo v-if="isAdd & content === 'internal_memo_bu'" @closeModal="closeModal" />

    <!-- Perorangan -->
    <NasionalP v-if="isAdd & content === 'nasional'" @closeModal="closeModal" />
    <InternasionalP v-if="isAdd & content === 'internasional'" @closeModal="closeModal" />
    <KhususP v-if="isAdd & content === 'khusus'" @closeModal="closeModal" />
    <InternalMemoP v-if="isAdd & content === 'internal_memo'" @closeModal="closeModal" />

  </div>
</template>
    
<script>
export default {
  props: {
    'isEdit': Boolean,
    'content': String,
    'currentTab': String,
  },

  components: {
    // Dokumen
    Default: () => import("@/components/masterdata/matrix/dokumen/add/default.vue"),
    Akta: () => import("@/components/masterdata/matrix/dokumen/add/akta.vue"),
    Komersial: () => import("@/components/masterdata/matrix/dokumen/add/komersial.vue"),
    Perizinan: () => import("@/components/masterdata/matrix/dokumen/add/perizinan.vue"),

    // Badan Usaha
    Nasional: () => import("@/components/masterdata/matrix/badan-usaha/add/nasional.vue"),
    Internasional: () => import("@/components/masterdata/matrix/badan-usaha/add/internasional.vue"),
    Khusus: () => import("@/components/masterdata/matrix/badan-usaha/add/khusus.vue"),
    InternalMemo: () => import("@/components/masterdata/matrix/badan-usaha/add/internal-memo.vue"),

    // Perorangan
    NasionalP: () => import("@/components/masterdata/matrix/perorangan/add/nasional.vue"),
    InternasionalP: () => import("@/components/masterdata/matrix/perorangan/add/internasional.vue"),
    KhususP: () => import("@/components/masterdata/matrix/perorangan/add/khusus.vue"),
    InternalMemoP: () => import("@/components/masterdata/matrix/perorangan/add/internal-memo.vue"),
  },

  data() {
    return {
      'isAdd': false,
    };
  },

  methods: {
    editShow() {
      this.$emit('editButton');
    },
    addShow() {
      this.isAdd = true;
    },
    closeModal() {
      this.isAdd = false;
    },
  },
}
</script>